<template>
  <div id="box">

    <div style="display: flex;flex-direction: row;justify-content: space-around;width: 100%;margin-top: 150px">

      <div class="contactitem">
        <div class="contacttitle">电子邮箱</div>
        <div class="contactvalue">
          {{ configdata.maile }}
        </div>
      </div>
      <div class="contactitem">
        <div class="contacttitle">在线客服</div>
        <div class="contactvalue">
          <el-button @click="openservice" type="primary">点击联系客服</el-button>
        </div>
      </div>
      <div class="contactitem">
        <div class="contacttitle"> 固定电话</div>
        <div class="contactvalue">
          029-81025379
        </div>
      </div>

    </div>


 <Footer></Footer>
  </div>
</template>

<script>
import {sendloginemail, conf_list, userlogin} from '@/api/manage' // 接口
import Footer from "@/components/footer";
export default {
  name: 'paytest',
  components: {Footer},
  props: {},
  data() {
    return {
      src: require('./images/4.png'),
      urls: require('./images/loginimg.png'),
      current: ['app'],
      configdata: {},
      projectname: '',
      billstatus: 0,
      company: "",
      drawer: 1,
      endtime: null,
      id: "",
      page: 1,
      pagesize: 10,
      service: "all",
      starttime: null,
      status: 0,
      yscode: "",
      codestate: 100,
      Index: 0,
      email: '',
      imgurlas: '',
      sIndexs: 1,
      form: {
        username: '',
        password: '',
        email: '',
        code: ''
      }
    }
  },
  mounted() {
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata

  },
  methods: {
    openservice(){
      window.open('http://service.xahuadao.com/chat/pc?token=dd58500b04dfaa2f68f2cb59da614644&noCanClose=1','_blank')
    },
    youxiang() {
      window.open('https://qy.163.com/login/?from=ym')
    },
    pictureprocessing(){
      this.$router.push('/seal/index');
    },
    DigitalCertificate(){
      this.$router.push('/');
    },
    handleSubmits(){
      this.$router.push('/login');
    },
    homepay() {
      this.$router.push('/');
    },
    login: function () {
      if (this.form.username.length < 5) {
        this.$message.info('请填写正确企业信用代码');
        return false
      } else if (!/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(this.form.email)) {
        this.$message.info('请填写正确邮箱');
        return false
      } else if (this.form.code == '') {
        this.$message.info('请填写正确邮箱验证码');
        return false
      } else {
        userlogin({email: this.form.username, code: this.form.code, yscode: this.form.username}).then(response => {
          localStorage.setItem("yscode", this.form.username)
          localStorage.setItem("emailcode", this.form.code)
          localStorage.setItem("email", this.form.email)
          this.$router.push('/user/orderlist');
        })
      }
    },
    verification(e) {
      var mailbox = this.form.email
      if (!/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(mailbox)) {
        this.$message.info('请填写正确邮箱！！！');
        return false
      } else {
        sendloginemail({email: mailbox, yscode: this.form.username}).then(response => {
        })
      }
    },
  },
}
</script>

<style lang="css" scoped>
@import './payTest.css';

#box {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
}

b {
  color: #333;
}

.contactitem{width: 300px;height: 300px;display: flex;flex-direction: column;align-items: center;justify-content: center}
.contacttitle{font-size: 30px}
.contactvalue{font-size: 35px}
.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: '';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}


/*                               */

</style>
